"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTablePagination = void 0;
const react_1 = require("react");
const useTablePagination = (filter, setLastSelectedRowId) => {
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [rowsPerPage, setRowsPerPage] = (0, react_1.useState)(20);
    (0, react_1.useEffect)(() => {
        setCurrentPage(1);
    }, [filter]);
    const handlePageChange = (0, react_1.useCallback)((newValue) => {
        setLastSelectedRowId(null);
        setCurrentPage(newValue);
    }, [setLastSelectedRowId]);
    const handleRowsPerPageChange = (0, react_1.useCallback)((newValue) => {
        setCurrentPage(1);
        setRowsPerPage(newValue);
    }, []);
    return {
        currentPage,
        rowsPerPage,
        handlePageChange,
        handleRowsPerPageChange,
    };
};
exports.useTablePagination = useTablePagination;
exports.default = exports.useTablePagination;
